import { useMemo } from 'react';
import { useMessage } from '@tmapy/intl';

import { RegistryEnum } from '../../openapi/types/RegistryEnum';
import { TypOsobyEnum } from '../../openapi/types/TypOsobyEnum';
import { registryMessages } from './subjectMessages';

export const useRegistry = (registry: RegistryEnum[] | null | undefined) => {
  const formatMessage = useMessage();

  return useMemo(() => {
    if (registry) {
      return registry.map((item) => {
        return formatMessage.lookup(registryMessages, item);
      });
    }

    return [];
  }, [registry]);
};

type useNazevProps = {
  typ_osoby: '' | TypOsobyEnum | null | undefined;
  nazev?: string | null;
  jmeno?: string;
  prijmeni?: string | null;
};

export const useNazev = (props: useNazevProps) => {
  return useMemo(() => {
    if (props.typ_osoby && props.typ_osoby === TypOsobyEnum.pravnickaOsoba) {
      return props.nazev;
    }
    // fyzickaOsoba
    return props.jmeno ? `${props.jmeno} ` : '' + props.prijmeni ? props.prijmeni : '';
  }, [props.typ_osoby, props.nazev, props.jmeno, props.prijmeni]);
};
